import { SliderMarkLabel } from "@mui/material";
import { useCallback, useMemo } from "react";

// based on https://github.com/mui/material-ui/issues/35861
export const ClickableSliderMarkLabel = (props: any) => {
  const { labelOnChange, ownerState, ...restProps } = props;

  const markValue = ownerState?.marks[props?.["data-index"]]?.value;

  const noop = useCallback((e: React.SyntheticEvent) => {
    e.stopPropagation();
  }, []);

  const onClick = useCallback(
    (e: React.SyntheticEvent) => {
      e.preventDefault();
      e.stopPropagation();

      if (markValue != null) {
        labelOnChange(e, markValue);
      }
    },
    [labelOnChange, markValue],
  );

  return (
    <SliderMarkLabel
      onMouseDown={noop}
      onTouchStart={noop}
      onClick={onClick}
      sx={useMemo(
        () => ({
          ...props?.sx,
          userSelect: "none",
        }),
        [props?.sx],
      )}
      ownerState={ownerState}
      {...restProps}
    />
  );
};

export function CustomTabPanel(props: { children?: React.ReactNode; compareValue: string; value: string }) {
  const { children, value, compareValue: index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} {...other}>
      {value === index && <>{children}</>}
    </div>
  );
}
